export const TEST_IDS = {
  SCA_HEADER_CLOSE_BUTTON: 'sca-header-close-button',
  SCA_CANCEL_PAYMENT_CTA: 'sca-cancel-payment-cta-button',
  SCA_CANCEL_PAYMENT_CLOSE_BUTTON: 'sca-cancel-modal-close-button',
  SCA_USERNAME_INPUT: 'sca-username-input',
  SCA_PASSWORD_INPUT: 'sca-password-input',
  SCA_REVEAL_PASSWORD: 'sca-reveal-password',
  SCA_CODE_INPUT: 'sca-code-input',
  SCA_LOGIN_VIEW_CTA: 'sca-login-view-cta-button',
  SCA_AUTHENTICATION_METHODS_VIEW_CTA:
    'sca-authentication-methods-view-cta-button',
  SCA_VERIFICATION_VIEW_CTA: 'sca-verification-view-cta-button',
  SCA_DECOUPLED_VERIFICATION_VIEW_ANIMATION: 'sca-mobile-loading',
  SCA_ALERT_BANNER: 'sca-alert-banner',
  AUTHENTICATION_VIEW: {
    PUSH_OTP: { method: 'push-otp-method', icon: 'push-otp-icon' },
    CHIP_OTP: { method: 'chip-otp-method', icon: 'chip-otp-icon' },
    SMS_OTP: { method: 'sms-otp-method', icon: 'sms-otp-icon' },
    PHOTO_OTP: { method: 'photo-otp-method', icon: 'photo-otp-icon' },
    REDIRECT: { method: 'redirect-method', icon: 'redirect-icon' },
  },
  BANK_NAME_LABEL: 'bank-name-label',
  USERNAME_INPUT_ERROR_ID: 'username-input-error',
  PASSWORD_INPUT_ERROR_ID: 'password-input-error',
  CODE_INPUT_ERROR_ID: 'code-input-error',
  CODE_INPUT_HELP_ID: 'code-input-help',
} as const;
